export const es_ES = {
  languageType: "es_ES",
  Property_Cloths: "Tejidos",
  Settings_Language: "Idioma",
  Tab_Shop: "Shop",
}